/* Speed fix 24 Oct 2026: preview videos play only while they are on screen.
   bb-light-video renders preview tiles with data-bb-lazyplay instead of autoplay, because
   the autoplay attribute makes the browser download every tile at page load, including
   ones far below the fold and hidden slick clones. Muted + playsinline keeps iPhone happy. */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('video[data-bb-lazyplay]').forEach(function (v) { v.autoplay = true; v.play().catch(function () {}); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.paused && !v.controls) { v.muted = true; v.play().catch(function () {}); }
      } else if (!v.paused && !v.controls) {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0.25 });
  var seen = new WeakSet();
  function scan(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('video[data-bb-lazyplay]').forEach(function (v) {
      if (seen.has(v)) return;
      seen.add(v);
      io.observe(v);
    });
  }
  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n.matches && n.matches('video[data-bb-lazyplay]') ? n.parentNode : n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
